module.exports = __webpack_public_path__ + "static/media/Portfolio.0a483874.svg";